import { httpClient } from '../httpClient';
import { IRvcModelAvailable } from '@packages/global';

export class RvcModelUserApi {
  async getAvailable(): Promise<IRvcModelAvailable[]> {
    return httpClient.get<IRvcModelAvailable[]>('/user/rvc-models/available');
  }
}

export const rvcModelUserApi = new RvcModelUserApi();
